"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SCHEDULING_VISIBILITY_CONSUMER = exports.SCHEDULING_VISIBILITY_AGENT = exports.CONSUMER_ROLE = exports.AGENT_ROLE = void 0;
const SCHEDULING_VISIBILITY_AGENT = exports.SCHEDULING_VISIBILITY_AGENT = 'agent:direct_book';
const SCHEDULING_VISIBILITY_CONSUMER = exports.SCHEDULING_VISIBILITY_CONSUMER = 'consumer:direct_book';
const AGENT_ROLE = exports.AGENT_ROLE = 'agent';
const CONSUMER_ROLE = exports.CONSUMER_ROLE = 'consumer';